import React from "react";
import { Link } from "react-router-dom";
import { BrandAvatar } from "./AdaptBrandSelector";

/**
 * Step indicator for the Adapt flow. Highlights the current step based on pathname.
 * currentStep: "generate" | "write_script"
 */
const AdaptStepIndicator = ({ baseUrlSlash, currentStep, brand }) => {
  return (
    <nav className="flex items-center gap-2 text-sm">
      {brand?.hash ? (
        <>
          <span className="inline-flex items-center gap-1.5 text-theme-text">
            <BrandAvatar brand={brand} size="sm" />
            <span className="truncate max-w-[180px]">{brand.name || "Brand"}</span>
          </span>
          <span className="text-theme-text opacity-40">→</span>
        </>
      ) : null}
      <Link
        to={`${baseUrlSlash}generate-ideas/`}
        className={currentStep === "generate" ? "font-semibold text-theme-primary" : "text-theme-text opacity-60 hover:opacity-90"}
      >
        Approve Ideas
      </Link>
      <span className="text-theme-text opacity-40">→</span>
      <span className={currentStep === "write_script" ? "font-semibold text-theme-primary" : "text-theme-text opacity-60"}>
        Generate Script
      </span>
    </nav>
  );
};

export default AdaptStepIndicator;
